var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8779 3.18444L7.99965 0L5.12854 3.18444C5.09975 3.21635 5.08082 3.25592 5.07406 3.29836C5.06729 3.3408 5.07298 3.38429 5.09043 3.42356C5.10788 3.46284 5.13635 3.49621 5.17238 3.51964C5.20841 3.54306 5.25045 3.55554 5.29343 3.55556H7.11076V8.66667C7.11076 8.7256 7.13418 8.78213 7.17585 8.8238C7.21753 8.86548 7.27405 8.88889 7.33299 8.88889H8.66632C8.72526 8.88889 8.78178 8.86548 8.82346 8.8238C8.86513 8.78213 8.88854 8.7256 8.88854 8.66667V3.55556H10.713C10.756 3.55554 10.798 3.54306 10.834 3.51964C10.8701 3.49621 10.8985 3.46284 10.916 3.42356C10.9334 3.38429 10.9391 3.3408 10.9324 3.29836C10.9256 3.25592 10.9067 3.21635 10.8779 3.18444Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6664 4.44434H11.5553V5.33322H14.222V14.2221H1.77756V5.33322H4.44423V4.44434H1.33312C1.21524 4.44434 1.1022 4.49116 1.01885 4.57451C0.935497 4.65786 0.888672 4.77091 0.888672 4.88878V14.6666C0.888672 14.7844 0.935497 14.8975 1.01885 14.9808C1.1022 15.0642 1.21524 15.111 1.33312 15.111H14.6664C14.7843 15.111 14.8974 15.0642 14.9807 14.9808C15.0641 14.8975 15.1109 14.7844 15.1109 14.6666V4.88878C15.1109 4.77091 15.0641 4.65786 14.9807 4.57451C14.8974 4.49116 14.7843 4.44434 14.6664 4.44434Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.4b36783fa9bb454f061b24620993253a.svg";
export { ForwardRef as ReactComponent };